import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import api from '@services/api';
import type { UserType } from '@customTypes/user';

const useGetUsersList = () => {
  const [users, setUsers] = useState<UserType[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getUsers = useCallback(async ({ page = 1, limit = 10, query = '' }) => {
    setLoading(true);
    try {
      const response = await api.get('/user', {
        params: {
          pageIndex: page,
          pageLimit: limit,
          query,
        },
      });

      setUsers(response.data.data);
      setTotalPages(response.data.total);
    } catch {
      toast.error('Erro ao carregar os usuários. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getUsers,
    users,
    totalPages,
    loading,
  };
};

export default useGetUsersList;
